import * as Sentry from "@sentry/react";

// Only disable Sentry in development environment, enable in all other environments (beta, prod)
const VITE_ENV = import.meta.env.VITE_ENV || 'dev';
const isDev = VITE_ENV === 'dev';

if (!isDev) {
  Sentry.init({
    dsn: "https://75c4d3c5d402a56f228c1e42000722e9@o4509366856187904.ingest.de.sentry.io/4509752134008912",
    environment: VITE_ENV,
    integrations: [
    ],
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [/^\//, /^https:\/\/api\.dondoncard\.com\/v1/, /^https:\/\/api-beta\.dondoncard\.com\/v1/],
  });
  
  console.log('[Sentry] Enabled for environment:', VITE_ENV);
} else {
  console.log('[Sentry] Disabled in development environment');
}
